import { useEffect, useRef } from 'react';
import { gsap } from '../lib/gsapSetup';
import ScrubWords from '../components/ScrubWords';
import SectionTag from '../components/SectionTag';
import { SHIFT } from '../content/siteContent';
import { useReducedMotion } from '../hooks/useMotionPrefs';

export default function TheShift() {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  useEffect(() => {
    if (reduced) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.shift-orb',
        { yPercent: -12, scale: 0.9 },
        {
          yPercent: 12,
          scale: 1.08,
          ease: 'none',
          scrollTrigger: { trigger: ref.current, start: 'top bottom', end: 'bottom top', scrub: true },
        }
      );
    }, ref);
    return () => ctx.revert();
  }, [reduced]);

  return (
    <section
      ref={ref}
      id="shift"
      data-testid="shift-section"
      className="relative overflow-hidden bg-[#000000] px-5 py-32 md:px-12 md:py-48"
    >
      <div className="shift-orb pointer-events-none absolute -right-40 top-1/4 h-[520px] w-[520px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(71,160,217,0.07) 0%, transparent 70%)' }} />
      <div className="mx-auto max-w-[1400px]">
        <SectionTag number="02" label="The Shift" />
        <ScrubWords
          text={SHIFT.statement}
          testId="shift-statement"
          className="mt-12 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-white sm:text-4xl md:mt-16 md:text-5xl lg:text-6xl"
        />
      </div>
    </section>
  );
}
